import React, { Component } from "react";
import Chart from "chart.js";
import PropTypes from "prop-types";

class KpiSummaryBarChart extends Component {
    constructor(props) {
        super(props);
        this.barRef = React.createRef();
    }

    componentDidUpdate() {
        this.barChart.data.labels = this.props.labels;
        this.barChart.data.datasets[0].data = this.props.sceneData;
        this.barChart.update();
    }

    componentDidMount() {
        this.barChart = new Chart(this.barRef.current, {
            type: "bar",
            options: {
                maintainAspectRatio: true,
                legend: {
                    display: false,
                },
                responsive: true,
                scales: {
                    yAxes: [
                        {
                            display: true,
                            ticks: {
                                min: 0,
                            },
                        },
                    ],
                    xAxes: [
                        {
                            scaleLabel: {
                                barPercentage: 0.2,
                            },
                            ticks: {
                                min: 0,
                            },
                        },
                    ],
                },
            },
            data: {
                labels: this.props.labels,
                datasets: [
                    {
                        backgroundColor: ["#bbf3bc", "#fdd048"],
                        data: this.props.sceneData,
                        borderWidth: 0.5,
                        barPercentage: 0.5,
                    },
                ],
            },
        });
    }

    render() {
        return (
            <div>
                <canvas id="barChart" style={{ height: "12rem" }} ref={this.barRef} />
            </div>
        );
    }
}
KpiSummaryBarChart.propTypes = {
    labels: PropTypes.array,
    data: PropTypes.array,
    sceneData: PropTypes.array,
};
KpiSummaryBarChart.defaultProps = {
    labels: [],
    data: [],
    sceneData: [],
};

export default KpiSummaryBarChart;
